import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaUniversity,
  FaUsers,
  FaChartLine,
  FaFileAlt,
  FaCreditCard,
  FaShieldAlt,
  FaStopwatch,
  FaPercentage,
  FaCheckCircle,
  FaDownload,
  FaStar,
  FaArrowRight,
  FaCog,
  FaBuilding,
  FaMoneyBillWave,
  FaCalculator,
  FaEye,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import "./ZaloznaPage.css";

const ZaloznaPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Modal state management
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const galleryImages = [
    '/zalozna/zalozna1.png',
    '/zalozna/zalozna2.png',
    '/zalozna/zalozna3.png'
  ];

  const openModal = (imageSrc) => {
    const index = galleryImages.indexOf(imageSrc);
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const features = [
    {
      icon: FaUsers,
      title: "Správa klientov",
      description:
        "Komplexná databáza klientov s históriou transakcií, úverov a všetkých finančných operácií",
    },
    {
      icon: FaMoneyBillWave,
      title: "Finančné operácie",
      description:
        "Spracovanie všetkých typov finančných transakcií vrátane vkladov, výberov a úverových operácií",
    },
    {
      icon: FaFileAlt,
      title: "Rozsiahle reporty",
      description:
        "Pokročilý systém reportovania a štatistík pre riadenie a compliance požiadavky",
    },
    {
      icon: FaCreditCard,
      title: "Platobné terminály",
      description:
        "Integrácia s platobnými terminálmi pre bezpečné a rýchle spracovanie platieb",
    },
    {
      icon: FaShieldAlt,
      title: "NIKÉ API integrácia",
      description:
        "Priame prepojenie s API spoločnosti NIKÉ pre aktuálne údaje a synchronizáciu",
    },
    {
      icon: FaChartLine,
      title: "Analytické nástroje",
      description:
        "Pokročilé analytické nástroje pre sledovanie výkonnosti pobočky a trendov",
    },
  ];

  const technologies = [
    {
      name: 'C#',
      description: 'Frontend a backend',
      color: '#239120'
    },
    {
      name: 'MSSQL',
      description: 'Databázový systém',
      color: '#cc2927'
    }
  ];

  const benefits = [
    {
      icon: FaStopwatch,
      title: "Rýchlosť obsluhy",
      value: "45%",
      description: "Zrýchlenie spracovania klientskych požiadaviek",
    },
    {
      icon: FaPercentage,
      title: "Efektivita práce",
      value: "60%",
      description: "Zvýšenie celkovej efektivity práce zamestnancov",
    },
    {
      icon: FaCheckCircle,
      title: "Presnosť údajov",
      value: "99.5%",
      description: "Minimalizácia chýb v finančných operáciách",
    },
    {
      icon: FaUsers,
      title: "Spokojnosť klientov",
      value: "92%",
      description: "Vysoká úroveň spokojnosti klientov s rýchlosťou obsluhy",
    },
  ];

  const industries = [
    {
      icon: FaUniversity,
      title: "Záložne a úverové spoločnosti",
      description:
        "Špecializované riešenie pre finančné inštitúcie typu záložňa",
    },
    {
      icon: FaBuilding,
      title: "Pobočkové siete",
      description: "Centralizované riadenie pre viacero pobočiek naraz",
    },
    {
      icon: FaCalculator,
      title: "Finančné poradenstvo",
      description:
        "Nástroje pre poskytovanie kvalitného finančného poradenstva",
    },
    {
      icon: FaShieldAlt,
      title: "Compliance a bezpečnosť",
      description:
        "Zabezpečenie súladu s finančnými reguláciami a bezpečnosť údajov",
    },
  ];

  const testimonials = [
    {
      name: "Ing. Mária Nováková",
      company: "NIKÉ Záložňa, pobočka Bratislava",
      text: "Aplikácia Záložňa výrazne zjednodušila našu každodennú prácu. API integrácia s centrálou funguje perfektne a reporty šetria hodiny práce.",
      rating: 5,
    },
    {
      name: "Bc. Peter Kováč",
      company: "NIKÉ Záložňa, pobočka Košice",
      text: "Platobné terminály sú bezproblémovo integrované a klienti si pochvaľujú rýchlosť obsluhy. Systém je veľmi intuitívny.",
      rating: 5,
    },
  ];

  return (
    <div className="zalozna-page">
      {/* Hero Section */}
      <section className="zalozna-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Záložňa WIN</h1>
              <h2>Aplikácia pre pobočky záložní</h2>
              <p>
                Desktopová aplikácia pre Windows, navrhnutá na efektívne
                riadenie činnosti pobočiek záložní. Softvér slúži ako každodenný
                pracovný nástroj pre zamestnankyne pobočiek. Aplikácia je
                prepojená s API spoločnosti NIKÉ, poskytuje rozsiahly súbor
                reportov a štatistík, obsahuje integráciu s platobnými
                terminálmi.
              </p>
              <div className="hero-actions">
                <Link to="/kontakt" className="btn btn-primary">
                  <FaArrowRight /> Získať ponuku
                </Link>
              </div>
            </div>
            <div className="hero-image">
              <img src="/zalozna.png" alt="Záložňa aplikácia" className="hero-product-image" />
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <h2>Ukážky aplikácie</h2>
          <div className="gallery-grid">
            <div className="gallery-item" onClick={() => openModal('/zalozna/zalozna1.png')}>
              <img src="/zalozna/zalozna1.png" alt="Záložňa aplikácia - ukážka 1" />
            </div>
            <div className="gallery-item" onClick={() => openModal('/zalozna/zalozna2.png')}>
              <img src="/zalozna/zalozna2.png" alt="Záložňa aplikácia - ukážka 2" />
            </div>
            <div className="gallery-item" onClick={() => openModal('/zalozna/zalozna3.png')}>
              <img src="/zalozna/zalozna3.png" alt="Záložňa aplikácia - ukážka 3" />
            </div>
          </div>
        </div>
      </section>

      {/* Technologies Section */}
      <section className="technologies-section">
        <div className="container">
          <h2>Použité technológie</h2>
          <div className="technologies-grid">
            {technologies.map((tech, index) => (
              <div key={index} className="technology-card">
                <div className="tech-name" style={{ color: tech.color }}>
                  {tech.name}
                </div>
                <p>{tech.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2>Kľúčové funkcie</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  <feature.icon />
                </div>
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2>Merateľné výsledky</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">
                  <benefit.icon />
                </div>
                <div className="benefit-value">{benefit.value}</div>
                <h4>{benefit.title}</h4>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="industries-section">
        <div className="container">
          <h2>Ideálne pre</h2>
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card">
                <div className="industry-icon">
                  <industry.icon />
                </div>
                <h4>{industry.title}</h4>
                <p>{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Customer Section */}
      <section className="customers-section">
        <div className="container">
          <h2>Naši klienti</h2>
          <div className="customers-grid">
            <a 
              href="https://www.kasa.sk/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="customer-card"
            >
              <img src="/kasa.jpg" alt="Kasa" />
              <h3>KASA ZÁLOŽNÁ a.s.</h3>
              <p>KASA ZÁLOŽNÁ a.s. je jednou z najväčších spoločností na Slovensku, poskytujúcich peňažnú hotovosť formou záložného práva.</p>
            </a>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {isModalOpen && (
        <div className="image-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <FaTimes />
            </button>
            <button className="modal-prev" onClick={prevImage}>
              <FaChevronLeft />
            </button>
            <img 
              src={galleryImages[currentImageIndex]} 
              alt={`Záložňa aplikácia - ukážka ${currentImageIndex + 1}`}
            />
            <button className="modal-next" onClick={nextImage}>
              <FaChevronRight />
            </button>
            <div className="modal-counter">
              {currentImageIndex + 1} / {galleryImages.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ZaloznaPage;
